import React from 'react';
import classNames from 'classnames';
import s from './Footer.scss';
export var FooterLogo = function (_a) {
    var _b;
    var brand = _a.brand, showNonBetaEditorXLogo = _a.showNonBetaEditorXLogo;
    return (React.createElement("div", { className: s.footerLogoWrapper, "data-hook": "footer-logo" },
        React.createElement("div", { "data-hook": "footer-logo-" + brand, className: classNames(s.logoSvg, brand, (_b = {},
                _b[s.newLogo] = !!showNonBetaEditorXLogo,
                _b)) })));
};
//# sourceMappingURL=FooterLogo.js.map